import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import AuthLayout from '../../shared/AuthLayout';
import ResetPasswordForm from '../../forms/auth/ResetPasswordForm';
import { createMessage } from '../../../utilities/utilities';
import Message from '../../shared/Message';
import { passwordReset } from '../../../services/auth';
import { handleError } from '../../../utilities/errorHandler';

const ResetPassword = () => {
  const { email, token } = useParams();
  const [ isSaving, setIsSaving ] = useState(false);
  const [ message, setMessage ] = useState({
    text: '',
    variant: '',
    show: false
  });
  const navigate = useNavigate();

  const handleMessage = (text, variant) => {
    setMessage(createMessage(text, variant));
  }

  const backToLogin = () => {
    navigate('/login');
  }

  const handleCloseMessage = () => {
    setMessage((prevMessage) => ({...prevMessage, show: false}));
  }

  const submitForm = async (data) => {
    setIsSaving(true);
    try {
      const passwordData = {
        token: token,
        email: email,
        password: data.password,
        password_confirmation: data.password_confirmation
      };

      const response = await passwordReset(passwordData);

      if (response.status === 200){
        handleMessage('You have successfully reset your password. Proceed to login.', 'success');
      }

      return true;
    } catch (error) {
      try {
        const errorMessage = handleError(error);
        if (errorMessage) {
          handleMessage(errorMessage.text, 'danger');
        } 
      } catch (e) {
        throw e; // error will be handled by the onSubmit() in ResetPasswordForm.jsx
      }
    } finally {
      await new Promise((resolve) => setTimeout(resolve, 500));
      setIsSaving(false);
    }
  }
  return (
    <AuthLayout
      title='Reset Password'>

      {message.show && (
        <Message
          message={message.text}
          handleClose={handleCloseMessage}
          variant={message.variant}
          show={message.show}
        />
      )}

      <ResetPasswordForm
        isSaving={isSaving}
        onBack={backToLogin}
        formAction={submitForm}
      />
    </AuthLayout>
  )

}

export default ResetPassword